import React from 'react';
import './personal-infos.scss';
import { Box, Button, Paper, Skeleton, Stack, Typography } from '@mui/material';
import { ReferenceDto } from '../../../../services/dtos/reference.dto';
import { UserDto } from '../../../../services/dtos/user.dto';
import moment from 'moment/moment';
import { InterlocutorsReferenceDto } from '../../../../services/dtos/interlocutors-reference.dto';
import { DeleteForever } from '@mui/icons-material';

//Props d'entrée de la fonction PersonalInfos
type Props = {
    civility?: ReferenceDto;
    interlocutor?: InterlocutorsReferenceDto;
    user?: UserDto;
    handleClickDeactivateAccount: any;
};

/**
 * Vue qui permet d'afficher les infos d'un compte
 * @param civility civilité de la personne connectée
 * @param interlocutor type interlocuteur de la personne connectée
 * @param user utilisateurs courant
 * @param handleClickDeactivateAccount Comportement au clic sur le bouton de désactivation de compte
 * @constructor
 */
function PersonalInfos({ civility, interlocutor, user, handleClickDeactivateAccount }: Props) {
    return (
        //Contenaire principal
        //Utilisation des stacks pour l'affichage des données
        //Utilisation de moment et format pour gérer les dates sans avoir de soucis avec les timeszones
        <Box className="container-register">
            <Typography variant={'h5'}>Mes infos personnelles</Typography>
            {interlocutor ? (
                <Paper>
                    <Stack spacing={2}>
                        <Stack direction="row" spacing={1}>
                            <Typography fontWeight="bold">Vous êtes un / une : </Typography>
                            <Typography>{interlocutor?.label}</Typography>
                        </Stack>
                        {!interlocutor?.moralPerson ? (
                            <Stack direction="row" spacing={1}>
                                <Typography fontWeight="bold">Civilité : </Typography>
                                <Typography>{civility?.label}</Typography>
                            </Stack>
                        ) : (
                            ''
                        )}
                        {user?.nomNaissance && user?.nomNaissance !== user?.nomUsage ? (
                            <Stack direction="row" spacing={1}>
                                <Typography fontWeight="bold">Nom de naissance : </Typography>
                                <Typography>{user?.nomNaissance}</Typography>
                            </Stack>
                        ) : (
                            ''
                        )}
                        <Stack direction="row" spacing={1}>
                            <Typography fontWeight="bold">Nom : </Typography>
                            <Typography>{user?.nomUsage}</Typography>
                        </Stack>
                        {!interlocutor?.moralPerson ? (
                            <>
                                <Stack direction="row" spacing={1}>
                                    <Typography fontWeight="bold">Prénom : </Typography>
                                    <Typography>{user?.prenom}</Typography>
                                </Stack>
                                <Stack direction="row" spacing={1}>
                                    <Typography fontWeight="bold">Date de Naissance : </Typography>
                                    <Typography>
                                        {user && user.dateNaissance
                                            ? moment(user.dateNaissance?.split('T')[0], true).format('DD/MM/yyyy')
                                            : ''}
                                    </Typography>
                                </Stack>
                            </>
                        ) : (
                            ''
                        )}
                        <Stack direction="row-reverse" spacing={1}>
                            <Button
                                variant="text"
                                sx={{
                                    color: '#f33446',
                                    '&:hover': {
                                        color: '#f33446',
                                    },
                                }}
                                onClick={handleClickDeactivateAccount}
                                startIcon={<DeleteForever style={{ marginRight: 5, width: '25px' }} />}
                            >
                                Désactiver mon compte
                            </Button>
                        </Stack>
                    </Stack>
                </Paper>
            ) : (
                <Skeleton variant="rectangular" height={100}></Skeleton>
            )}
        </Box>
    );
}

export default PersonalInfos;
